export default function removeAllSlides() {
  var swiper = this;
  var slidesIndexes = [];

  for (var i = 0; i < swiper.slides.length; i += 1) {
    slidesIndexes.push(i);
  }

  swiper.removeSlide(slidesIndexes);
}


//////////////////
// WEBPACK FOOTER
// /Users/jordan/www/sites/chryso/wwwroot/wp-content/themes/chryso-v2/node_modules/swiper/esm/components/core/manipulation/removeAllSlides.js
// module id = 221
// module chunks = 0